<template>
  <nav class="home-toc card" aria-label="On this page">
    <h2 class="home-toc-title">On this page</h2>
    <ul class="home-toc-list">
      <li v-for="item in items" :key="item.id">
        <a :href="'#' + item.id">{{ item.label }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'HomeToc',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
